import axios, { AxiosRequestConfig, AxiosResponse } from "axios";
import { showErrorToast } from "../utils/utils";

export const customAxios = async (
  config: AxiosRequestConfig,
): Promise<AxiosResponse<any>> => {
  const results = await axios({
    baseURL: process.env.REACT_APP_SERVER_URL,
    headers: {
      "Content-Type": "application/json",
    },
    ...config,
  }).catch((error) => {
    if ([503, 401].includes(error.status)) {
      // tmp: remove 401
      localStorage.removeItem("accessToken");
      localStorage.removeItem("refreshToken");
      localStorage.removeItem("profile");
      window.location.href = "/login";
      return Promise.reject(new Error("Unauthorized or Service Unavailable"));
    }

    if (
      ![404].includes(error.status) &&
      !error.request.responseURL.includes("/user_config/analytics")
    ) {
      showErrorToast("Something went wrong", {
        key: "axios_error",
        preventDuplicate: true,
      });
      return Promise.reject(new Error("Something went wrong"));
    }

    // throw error; // Re-throw the error to be handled by the caller
    return Promise.reject(error);
  });
  return results;
};
